<div class="featured-games">
  <h2 class="title">
    <span class="icon"><img src="../../../../assets/images/star.png" alt="Star"></span> Featured Games
  </h2>

  <div class="games-container">
    <div *ngFor="let game of games" class="game-card">
      <div class="game-image">
        <img class="mainImg" [src]="game.image" [alt]="game.name" />
        <img class="additionalImg" *ngIf="game.additionalImage" [src]="game.additionalImage" [alt]="game.name" />
        <span class="points">{{ game.points }} pts</span>
      </div>

      <div class="game-info">
        <h3>{{ game.name }}</h3>
        <div class="game-action">
          <p class="players"><span class="icon"><img src="../../../../assets/images/players.png" alt="Players"></span> {{ game.players }} playing</p>
          <button class="play-button btn" (click)="openModal(game)">Play Now</button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal
  [isOpen]="isAddPointsModalOpen"
  [icon]="'assets/images/coin.png'"
  [title]="'Add points to continue'"
  [text]="'You’re out of game points! Purchase more to continue your adventure.'"
  [primaryBtnText]="'Purchase Points'"
  [secondaryBtnText]="'Maybe Later'"
  (primaryClick)="goToShop()"
  (secondaryClick)="closeModal()"
  (close)="closeModal()">
</app-modal>

<app-modal
  [isOpen]="isModalOpen"
  [icon]="'assets/images/coin.png'"
  [title]="'Ready to play?'"
  [text]="modalText"
  [primaryBtnText]="'Play Now'"
  [secondaryBtnText]="'Cancel'"
  (primaryClick)="startGame()"
  (secondaryClick)="closeModal()"
  (close)="closeModal()">
</app-modal>
